import { CheckoutUIProvider } from "../CheckoutUIProvider";
import CheckoutFormInner from "./CheckoutForm";

const CheckoutForm = () => {
  return (
    <CheckoutUIProvider>
      <CheckoutFormInner />
    </CheckoutUIProvider>
  );
};

export default CheckoutForm;
